import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Storage from '@/utils/storage'

import en from '@/lang/en'
import vi from '@/lang/vi'

Vue.use(VueI18n)

const fallbackLocale = 'en'
const locale = Storage.get('LOCALE_DEFAULT', 'en') || 'en'

const i18n = new VueI18n({
  fallbackLocale,
  locale,
  messages: { en, vi },
  silentFallbackWarn: true
})

export default i18n
